import * as Actions from "../actions/_ActionTypes";
import * as Pre from "../actions/_PreActionNames";
import CacheStorage from "../modules/cacheStorage";
// const initState = [...Data.areas];
const initState = {
  scenarios: [],
  runResult: null,
  isLoading: false,
  InitializedFromCache: false,
};

const ScenarioReducer = (state = initState, action) => {
  const _state = { ...state };
  // if (_state.scenarios.length == 0 && !_state.InitializedFromCache) {
  //   SecureStore.getActiveProfile()
  //     .then((profile) => {
  //       var buildingId = "";
  //       if (profile && profile.id) buildingId = profile.id;

  //       new CacheStorage().QuickAccess.GetScenarioQuickAccess(buildingId)
  //         .then((scenarios) => {
  //           if (Array.isArray(scenarios) && scenarios.length > 0) {
  //             var scenarioModels = scenarios.map((s) => {
  //               // generate fake scenario-ish objects to show correct item in shortcut board
  //               return {
  //                 id: s.id,
  //                 name: s.name + " cache",
  //                 _mainConditionType: "virtual",
  //                 showDashboardShortcut: true,
  //                 conditions: [
  //                   {
  //                     iconName: s.icon,
  //                     isMain: true,
  //                     baseType: "virtual",
  //                   },
  //                 ],
  //               };
  //             });
  //             _state.scenarios = scenarioModels;
  //             _state.InitializedFromCache = true;
  //             _state.isLoading = false;
  //           }
  //         })
  //         .catch(console.log);
  //     })
  //     .catch(console.log);
  // }
  if (action.socket && action.socket.send) {
    // leave request to handle by server
    if (action.type.indexOf("SCENARIO") == 0) {
      _state.isLoading = true;
    }
    return _state;
  }
  var parsedData = null;
  if (action.payload && action.payload.data) {
    parsedData = JSON.parse(action.payload.data);
  }

  switch (action.type) {
    case Pre.SCENARIO + Actions.ALL:
      if (!parsedData) break;
      if (parsedData && !Array.isArray(parsedData)) {
        parsedData = [parsedData];
      }
      _state.scenarios = parsedData || [];
      var scenariosShortcut = _state.scenarios.filter(
        (s) => s.showDashboardShortcut && s._mainConditionType != "device"
      );
      var cacheStorage = new CacheStorage();
      if (scenariosShortcut.length != 0) {
        cacheStorage.QuickAccess.SetScenarioQuickAccess([...scenariosShortcut]);
      }
      _state.isLoading = false;
      break;

    case Pre.SCENARIO + Actions.ALL_CACHE:
      /* SCENARIO_ALL will write data to cache storage. but SCENARIO_ALL_CACHE is already from cache and should not re-write */
      if (Array.isArray(action.payload)) {
        _state.scenarios = [...action.payload];
      }

      break;

    case Pre.SCENARIO + Actions.DETAILS:
    case Pre.SCENARIO + Actions.ADD:
      var model = parsedData || action.payload;
      // console.log("model in scenarioReducer.add()", model.id, model.hasDetail);

      if (
        _state.scenarios.some((s) => s?.id == model?.id || s?.uId == model?.uId)
      ) {
        for (var i in _state.scenarios) {
          var current = _state.scenarios[i];
          if (current?.id == model?.id || current?.uId == model?.uId) {
            _state.scenarios[i] = { ...model };
            break;
          }
        }
      } else {
        _state.scenarios.push(model);
      }
      var scenariosShortcut = _state.scenarios.filter(
        (s) => s.showDashboardShortcut && s._mainConditionType != "device"
      );
      var cacheStorage = new CacheStorage();
      cacheStorage.QuickAccess.SetScenarioQuickAccess([...scenariosShortcut]);
      _state.isLoading = false;
      break;

    case Pre.SCENARIO + Actions.REMOVE:
      // console.log("payload in scenarioReducer.remove()", parsedData);
      let { scenarioId, scenarioUId } = parsedData || action.payload;
      if (scenarioUId) {
        for (var i in _state.scenarios) {
          if (_state.scenarios[i].uId == scenarioUId) {
            _state.scenarios.splice(i, 1);
            break;
          }
        }
      } else if (scenarioId > 0) {
        for (var i in _state.scenarios) {
          if (_state.scenarios[i].id == scenarioId) {
            _state.scenarios.splice(i, 1);
            break;
          }
        }
      }
      var scenariosShortcut = _state.scenarios.filter(
        (s) => s.showDashboardShortcut && s._mainConditionType != "device"
      );
      var cacheStorage = new CacheStorage();
      cacheStorage.QuickAccess.SetScenarioQuickAccess(scenariosShortcut);
      _state.isLoading = false;
      break;

    case Pre.SCENARIO + Actions.TOGGLE_ENABLE:
      if (parsedData.scenarioId > 0) {
        for (var i in _state.scenarios) {
          if (_state.scenarios[i].id == parsedData.scenarioId) {
            _state.scenarios[i].enable = parsedData.enable;
            break;
          }
        }
        var scenariosShortcut = _state.scenarios.filter(
          (s) => s.showDashboardShortcut && s._mainConditionType != "device"
        );
        var cacheStorage = new CacheStorage();
        cacheStorage.QuickAccess.SetScenarioQuickAccess([...scenariosShortcut]);
      }
      _state.isLoading = false;
      break;
    // case Pre.APP + Actions.RECONNECT:
    //   console.log("APP_RECONNECT received in ScenarioReducer");
    //   _state.scenarios = [];
    //   break;
    case Actions.CLEAR_CACHE:
    case Actions.LOGOUT:
      // console.log("clear ScenarioReducer due to LOGOUT");
      _state.scenarios = [];
      _state.InitializedFromCache = false;
      new CacheStorage().QuickAccess.ClearAll();
      break;

    // === Run Result ===
    case Pre.SCENARIO + Actions.RUN_RESULT:
      if (Object.keys(parsedData).length > 0) {
        _state.runResult = parsedData;
      }
      break;
    case Pre.SCENARIO + Actions.CLEAR_RUN_RESULT:
      _state.runResult = null;
      break;
    default:
      break;
  }

  return _state;
};

export default ScenarioReducer;
